module.exports = __webpack_public_path__ + "img/arrow-black-down.87edff6d.svg";